export const privacyLink = "U_P5ic";
export default {privacyLink};